<template>
  <div
    id="SystemDevelopmentDivisionTerimel"
    :style="{
      width: '1920px',
      height: '1080px',
      'transformOrigin':'left top',
      'transform':`scale(${scalseNum})`,
      '-webkit-transform':`scale(${scalseNum})`,
      '-moz-transform':`scale(${scalseNum})`,
      '-o-transform':`scale(${scalseNum})`,
      '-ms-transform':`scale(${scalseNum})`
    }"
  >
    <div class="header main-header">
      <div class="header-left">
        <div class="site-name xx">
          {{ name }}
        </div>
        <span class="xx">更新时间：{{ cutOffDate }}</span>
      </div>
      <div class="header-right">
        <span class="goback" @click="goback">返回</span>
      </div>
    </div>
    <div class="main-body">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import scalseNum from '@/mixins/scalseNum.js'

export default {
  mixins: [scalseNum],
  name: '',
  props: {
    name: {}
  },
  data () {
    return {
      cutOffDate: '',
      mfData: {}
    }
  },
  computed: {

  },
  created () {
    // this.getProject()
  },
  mounted () {
    this.cutOffDate = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
  },
  watch: {

  },
  methods: {

    goback () {
      window.history.go(-1)
    }
  },
  activated () {
  }

}
</script>

<style scoped lang="stylus">
#SystemDevelopmentDivisionTerimel
  >>>
    .business-box
      height:40rem
.main-header
  width 100%
  color #fff
  background #1A1939
  height 3.2rem
  display flex
  padding  0 1rem
  box-sizing: border-box
  .header-left
    font-size 1.2rem
    height 3.2rem
    line-height 3.2rem
    color #FFFFFF
    flex 1
    .xx
      float left
    .logo
      background-repeat no-repeat
    img
      display inline-block
      margin-right .3rem
      vertical-align text-bottom
      height 1.1rem
    span
      font-size .8rem
      color rgba(255,255,255,.6)
      padding-left .5rem
  .header-right
    width 100px
    display: inline-block
    align-self center
    cursor pointer
.main-body
  padding 1rem
  padding-bottom 0
  height 100%
  // margin-top 1rem
  // height calc(100vh - 4.2rem)
  // width calc(100vw - 2rem)
  // margin 1rem auto 0 auto
  // overflow hidden
</style>
